import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { ColoredCard } from "@/uiKit/atoms/ColoredCard.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export const GestationalFormWarning = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);
  return (
    <ColoredCard color="blue">
      <CardContent>
        <Typography className={styles.bold}>
          {t("diabetesForms.nonTelemonitoredPatient")}
          {" : "}
        </Typography>
        <Typography>{t("diabetesForms.noInsulinMonitoringHelpText")}</Typography>
      </CardContent>
    </ColoredCard>
  );
};

const makeStyles = () => ({
  bold: css({ fontWeight: "bold" }),
});
